import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../scripts/AuthContext";
import { useSocialDmSocket } from "../scripts/SocialDmSocketContext";
import { listSocialDmConversations } from "@/lib/socialDmApi";

export function useSocialDmConversations(opts = {}) {
  const { accessToken } = useAuth();
  const { subscribe } = useSocialDmSocket();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const unreadOnly = !!opts.unreadOnly;

  const refresh = useCallback(async () => {
    if (!accessToken) {
      setConversations([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await listSocialDmConversations(accessToken, { unreadOnly });
      setConversations(data);
    } catch (err) {
      console.error("Failed to load social DM conversations:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [accessToken, unreadOnly]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    return subscribe((event) => {
      if (
        event === "social-dm.message" ||
        event === "social-dm.read"
      ) {
        refresh();
      }
    });
  }, [subscribe, refresh]);

  return {
    conversations,
    allConversations: conversations,
    loading,
    error,
    refresh,
    setConversations,
  };
}
